export const hasErrors = "has-errors";
export const isRequiredAfter = "is-required--after";
export const isRequiredGroupAfter = "is-required-group--after";
export const isRequiredBefore = "is-required--before";
export const isRequiredGroupBefore = "is-required-group--before";
